// IndicatorPanel — Add/remove indicators
import React from 'react';
import { INDICATORS } from '../../../config/tradingConstants';

export default function IndicatorPanel({ activeIndicators, onToggle }) {
  return (
    <div className="bg-white border border-gray-200 rounded-lg shadow-sm p-3">
      <h4 className="text-[10px] font-semibold text-gray-400 uppercase tracking-wider mb-2">Indicators</h4>
      <div className="flex flex-wrap gap-1.5">
        {INDICATORS.map(ind => {
          const isActive = activeIndicators.includes(ind.key);
          return (
            <button
              key={ind.key}
              onClick={() => onToggle(ind.key)}
              className={`px-2.5 py-1 rounded-lg text-[10px] font-medium transition-all border ${
                isActive
                  ? 'bg-blue-50 text-blue-600 border-blue-200'
                  : 'bg-gray-50 text-gray-500 border-gray-200 hover:bg-gray-100'
              }`}
            >
              {ind.label}
              {ind.overlay ? '' : ' \u2193'}
            </button>
          );
        })}
      </div>
    </div>
  );
}
